import { render, staticRenderFns } from "./CommentTab.vue?vue&type=template&id=1bf1f91a&scoped=true"
import script from "./CommentTab.vue?vue&type=script&lang=ts"
export * from "./CommentTab.vue?vue&type=script&lang=ts"
import style0 from "./CommentTab.vue?vue&type=style&index=0&id=1bf1f91a&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf1f91a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf1f91a')) {
      api.createRecord('1bf1f91a', component.options)
    } else {
      api.reload('1bf1f91a', component.options)
    }
    module.hot.accept("./CommentTab.vue?vue&type=template&id=1bf1f91a&scoped=true", function () {
      api.rerender('1bf1f91a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/CommentTab.vue"
export default component.exports